/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2183
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.zh_hant = undefined
exports.zh_hant = {
  DUPLICATE_BLOCK: "複製",
  COPY_ALL: "複製所有積木（ %1 個)",
  ADD_COMMENT: "加入註解",
  REMOVE_COMMENT: "移除註解",
  DELETE_BLOCK: "刪除積木",
  DELETE_X_BLOCKS: "刪除所有積木（ %1 個）",
  DELETE_ALL_BLOCKS: "刪除共 %1 個積木？",
  CLEAN_UP: "整理積木",
  COLLAPSE_BLOCK: "收合積木",
  COLLAPSE_ALL: "收合積木",
  EXPAND_BLOCK: "展開積木",
  EXPAND_ALL: "展開所有積木",
  UNDO: "撤销",
  REDO: "重試",
  PASTE: "粘貼",
  COPY_AND_PASTE: "複製並粘貼",
  GLOBAL_COMMENT: "添加全局註釋",
  COMMENT: "註釋",
  BLUE_COMMENT: "藍色註釋",
  GREEN_COMMENT: "綠色註釋",
  YELLOW_COMMENT: "黃色註釋",
  RED_COMMENT: "紅色註釋",
  DELETE_COMMENT: "刪除註釋",
  WHATS_THIS: "這是什麼功能…",
  SAY_SOMETHING: "說些什麼…",
  START_ON_CLICK: "%1 當 開始 被點擊",
  start_on_click_2: "%1 當 開始 被點擊 %2 %3",
  ON_RUNNING_GROUP_ACTIVATED: "%1 當 切換到 當前屏幕",
  SELF_LISTEN: "%1 當 收到 廣播 %2 %3 %4",
  SELF_BROADCAST: "發送廣播 %1",
  SELF_BROADCAST_AND_WAIT: "發送廣播 %1 並等待",
  WHEN: "%1 當 %2 %3",
  TERMINATE: "停止",
  REPEAT_FOREVER: "重複執行 %1 %2",
  REPEAT_N_TIMES: "重複執行 %1 次 %2 %3",
  REPEAT_FOREVER_UNTIL: "重複執行直到 %1 %2 %3",
  BREAK: "退出循環",
  WARP: "一步執行 %1 %2",
  WAIT_SECS: "等待 %1 秒",
  WAIT_UNTIL: "保持等待直到 %1",
  DESTRUCT: "銷毀自身",
  CONTROLS_IF_MSG_IF: "如果",
  CONTROLS_IF_MSG_ELSEIF: "否則如果",
  CONTROLS_IF_MSG_ELSE: "否則",
  CONTROLS_IF_TOOLTIP_1: "當值為 true 時，執行一些陳述式。",
  CONTROLS_IF_TOOLTIP_2: "當值為 true 時，執行第一個陳述式，否則，執行第二個陳述式。",
  CONTROLS_IF_TOOLTIP_3: "如果第一個值為 true，則執行第一個陳述式。否則，當第二個值為 true 時，則執行第二個陳述式。",
  CONTROLS_IF_TOOLTIP_4: "如果第一個值為 true，則執行第一個陳述式。否則當第二個值為 true 時，則執行第二個陳述式。如果前幾個敘述都不為 ture，則執行最後一個陳述式。",
  TELL: "告訴 %1 執行 %2 %3",
  SYNC_TELL: "告訴 %1 執行並等待 %2 %3",
  GET_TIME: "當前 %1",
  YEAR: "年",
  MONTH: "月",
  DATE: "日",
  WEEK: "星期",
  WEEK0: "星期日",
  WEEK1: "星期一",
  WEEK2: "星期二",
  WEEK3: "星期三",
  WEEK4: "星期四",
  WEEK5: "星期五",
  WEEK6: "星期六",
  HOUR: "小時",
  MINUTE: "分鐘",
  SECOND: "秒",
  TIMER: "計時器",
  RESET_TIMER: "重置 計時器",
  MATH_NUMBER_TOOLTIP: "一個數字。",
  RANDOM_NUM: "在 %1 到 %2 間隨機整數",
  DIVISIBLE_BY: "%1 能被 %2 整除",
  CALCULATE: "數學運算 %1",
  CALCULATE_TOOLTIPS: "輸入數學等式進行運算",
  MATH_ARITHMETIC: "%1 %2 %3",
  MATH_ARITHMETIC_TOOLTIP_ADD: "返回兩個數字的總和。",
  MATH_ARITHMETIC_TOOLTIP_MINUS: "返回兩個數字的差。",
  MATH_ARITHMETIC_TOOLTIP_MULTIPLY: "返回兩個數字的乘積。",
  MATH_ARITHMETIC_TOOLTIP_DIVIDE: "返回兩個數字的商。",
  MATH_ARITHMETIC_TOOLTIP_POWER: "返回第二個數字的指數的第一個數字。",
  MATH_SINGLE: "%1 %2",
  MATH_SINGLE_OP_ROOT: "算數平方根",
  MATH_SINGLE_TOOLTIP_ROOT: "返回指定數字的平方根。",
  MATH_SINGLE_OP_ABSOLUTE: "絕對值",
  MATH_SINGLE_TOOLTIP_ABS: "返回指定數字的絕對值。",
  MATH_SINGLE_TOOLTIP_NEG: "返回指定數字的逻辑非",
  MATH_SINGLE_TOOLTIP_LN: "返回指定數字的自然對數。",
  MATH_SINGLE_TOOLTIP_LOG10: "返回指定數字的對數。",
  MATH_SINGLE_TOOLTIP_EXP: "返回指定數字指數的 e",
  MATH_SINGLE_TOOLTIP_POW10: "返回指定數字指數的10的冪次。",
  MATH_ROUND: "%1 %2",
  MATH_ROUND_TOOLTIP: "將數字無條件進位或無條件捨去。.",
  MATH_ROUND_OPERATOR_ROUND: "四捨五入",
  MATH_ROUND_OPERATOR_ROUNDUP: "向上舍入",
  MATH_ROUND_OPERATOR_ROUNDDOWN: "向下舍入",
  MATH_MODULO_TITLE: "%1 ÷ %2 的餘數",
  MATH_MODULO_TOOLTIP: "回傳兩個數字相除的餘數。",
  MATH_NUMBER_PROPERTY: "%1 %2",
  MATH_IS_EVEN: "是偶数",
  MATH_IS_ODD: "是奇数",
  MATH_IS_PRIME: "是质数",
  MATH_IS_WHOLE: "是整数",
  MATH_IS_POSITIVE: "是正数",
  MATH_IS_NEGATIVE: "是负数",
  MATH_IS_TOOLTIP: "如果数字是偶数、奇数、非负整数、正数、负数或如果它可被某数字整除，则返回真或假。",
  MATH_DEGREES: "度",
  LOGIC_NEGATE_TITLE: "%1 不成立",
  LOGIC_BOOLEAN_TRUE: "成立",
  LOGIC_BOOLEAN_FALSE: "不成立",
  LOGIC_BOOLEAN_TOOLTIP: "返回真或假。",
  LOGIC_COMPARE: "%1 %2 %3",
  LOGIC_COMPARE_TOOLTIP_EQ: "如果這兩個輸入區塊的結果相等，返回 true。",
  LOGIC_COMPARE_TOOLTIP_NEQ: "如果這兩個輸入區塊的結果不相等，返回 true。",
  LOGIC_COMPARE_TOOLTIP_LT: "如果第一個輸入結果比第二個小，返回 true。",
  LOGIC_COMPARE_TOOLTIP_LTE: "如果第一個輸入結果小於或等於第二個，返回 true。",
  LOGIC_COMPARE_TOOLTIP_GT: "如果第一個輸入結果大於第二個，返回 true。",
  LOGIC_COMPARE_TOOLTIP_GTE: "如果第一個輸入結果大於或等於第二個，返回 true。",
  LOGIC_OPERATION: "%1 %2 %3",
  LOGIC_OPERATION_AND: "且",
  LOGIC_OPERATION_OR: "或",
  LOGIC_OPERATION_TOOLTIP_AND: "如果兩個輸入結果都為 true，則返回 true。",
  LOGIC_OPERATION_TOOLTIP_OR: "如果至少一個輸入結果為 true，返回 true。",
  TEXT_TEXT_TOOLTIP: "一個字元、一個單詞，或一串文字。",
  TEXT_SELECT: "%1 的第 %2 到第 %3 個字元",
  TEXT_LENGTH: "%1 的長度",
  TEXT_CONTAIN: "%1 包含 %2",
  TEXT_SPLIT: "把 %1 按 %2 分開成列表",
  TEXT_JOIN_TOOLTIP: "通過連接任意數量的項目來建立一串文字。",
  TEXT_JOIN_TITLE_HEAD: "把",
  TEXT_JOIN_TITLE_TAIL: "放在一起",
  VARIABLES_GET: "%1",
  VARIABLES_SET: "設置變量 %1 的值为 %2",
  CHANGE_VARIABLE: "將變量 %1 %2 %3",
  INCREASE: "增加",
  DECREASE: "減少",
  LISTS_GET: "%1",
  LISTS_APPEND: "添加 %1 到 %2 末尾",
  LISTS_INSERT_VALUE: "插入 %3 到 %1 的第 %2 項",
  LISTS_COPY: "複製 %2 到 %1",
  LISTS_LENGTH: "%1 的長度",
  LISTS_IS_EXIST: "%1 中包含 %2",
  LISTS_INDEX_OF: "%2 中第一個 %1 的位置",
  PROCEDURES_PARAMETER: "參數%1",
  PROCEDURES_RETURN_VALUE: "返回 %1 %2",
  PROCEDURES_DEFNORETURN_TITLE: "定義函數",
  PROCEDURES_DEFNORETURN_PROCEDURE: "函數",
  PROCEDURES_DEFNORETURN_TOOLTIP: "創建一個函數。",
  PROCEDURES_DEFRETURN_RETURN: "返回",
  COLOR_PICKER: "%1",
  RED: "紅色",
  GREEN: "綠色",
  BLUE: "藍色",
  HUE: "色相",
  SATURATION: "飽和度",
  BRIGHTNESS: "亮度",
  OPACITY: "不透明度",
  SELECT_COLOR_PARAM_TYPE: "選參方式",
  COLOR_PREVIEW: "顏色預覽"
}
